var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass: "component-html",
    domProps: { innerHTML: _vm._s(_vm.component.html) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }